import * as defaultImport from "@splunk/dashboard-layouts/visualizations/ConnectedLine";
export * from "@splunk/dashboard-layouts/visualizations/ConnectedLine";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
